import { proxyClientOptions, RestfulClient, Session } from '@benzinga/session';
import { SafePromise } from '@benzinga/safe-await';
import { SymbolsResult } from '../../entities';
import { AutoCompleteEnvironment } from '../../environment';
import { autocompleteSymbolsRoutes } from './routes';
import { AutocompleteSymbolsTransport } from './types';

export class AutocompleteSymbolRestful extends RestfulClient implements AutocompleteSymbolsTransport {
  constructor(session: Session) {
    const env = session.getEnvironment(AutoCompleteEnvironment);
    super(env.symbolsUrl, session, {}, proxyClientOptions(undefined, 'apikey'));
  }

  getAutoCompleteSymbols = async (query: string, limit = 10, types?: string): SafePromise<SymbolsResult> => {
    const env = this.session.getEnvironment(AutoCompleteEnvironment);
    const path = this.routePath(autocompleteSymbolsRoutes.symbols);
    const params = types ? { limit, query, types } : { limit, query };
    const url = this.URL(path, this.withUpstreamCredentials(params, { apikey: env.symbolsKey }));
    return this.get<SymbolsResult>(url, { allowsAnonymousAuth: true, credentials: 'same-origin' });
  };
}
